import React, { useState } from 'react';
import Books from '../../Pages/Site/Books/Books';
import { Route, Routes } from 'react-router-dom';
import { Mybooks } from "../../Pages/Site/Mybooks/Mybooks";
import SiteHeader from '../../Components/Macro/SiteHeader/SiteHeader';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import { Container } from 'react-bootstrap';
import Home from '../../Pages/Site/Home/Home';
import SiteFooter from '../../Components/Macro/Footer/SiteFooter';
import About from '../../Pages/Site/About/About';
import Posts from '../../Pages/Site/Posts/Posts';
import SinglePost from '../../Pages/Site/Posts/SinglePost';
import Videos from '../../Pages/Site/Videos/Videos';
import Player from '../../Pages/Site/Videos/Player';
import { Drawer } from 'antd';
import ChatIntelect from './ChatIntelect';
import Forum from '../../Pages/Site/Forum/Forum';
import TopicDiscussion from '../../Pages/Site/Forum/TopicDiscussion';
import axios from 'axios';
import Music from '../../Pages/Site/Audio/Music';
import SingleBook from '../../Pages/Site/Books/SingleBook';
import { SavingLoaderProvider } from '../../Components/SavingLoader/SavingLoader';
import Privacy from '../../Pages/Site/Privacy/Privacy';
import TgPosts from '../../Pages/Site/TgPage/TgPosts';
import { AiFillOpenAI } from "react-icons/ai";
import Qaror from '../../Pages/Site/Posts/Qaror';
import MobileApp from '../../Pages/Site/MobileApp/MobileApp';


function Site({ db, request }) {
    let [aidraw, setAidraw] = useState(false);

    axios.defaults.headers.common['Content-Type'] = "application/json"

    return (
        <SavingLoaderProvider>
            <div>
                <SiteHeader />
                <Container style={{ padding: '10px 10px 100px 10px', marginBottom: '60px', borderRadius: '15px' }} >
                    <Routes>
                        <Route path='/' element={<Home request={request} db={db} />} />
                        <Route path='/books' element={<Books db={db} />} />
                        <Route path='/book/:id' element={<SingleBook db={db} />} />
                        <Route path='/forum' element={<Forum db={db} />} />
                        <Route path='/forum/topic/:topicId' element={<TopicDiscussion />} />
                        <Route path='/posts' element={<Posts request={request} />} />
                        <Route path='/videos' element={<Videos request={request} />} />
                        <Route path='/music' element={<Music request={request} />} />
                        <Route path='/post/:id' element={<SinglePost request={request} />} />
                        <Route path='/video/:id' element={<Player request={request} />} />
                        <Route path='/about' element={<About request={request} />} />
                        <Route path='/mybooks' element={<Mybooks db={db} />} />
                        <Route path='/privacy' element={<Privacy />} />
                        <Route path='/tgposts' element={<TgPosts />} />
                        <Route path='/hujjatlar' element={<Qaror />} />
                        <Route path='/mobile' element={<MobileApp />} />
                        <Route path='/*' element={<div style={{ textAlign: 'center', padding: '80px 20px' }}><h2>404 — Sahifa topilmadi</h2></div>} />
                    </Routes>
                </Container>
                <SiteFooter />
                <button
                    onClick={() => setAidraw(true)}
                    style={{
                        position: 'fixed',
                        bottom: '90px',
                        right: '18px',
                        zIndex: 999,
                        width: '54px',
                        height: '54px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                        color: '#fff',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '24px',
                        boxShadow: '0 4px 20px rgba(79,70,229,0.45)',
                        animation: 'aiPulse 2.5s ease-in-out infinite',
                    }}
                    title="AI Maslahatchi"
                >
                    <AiFillOpenAI />
                </button>
                <Drawer title="🤖 AI Maslahatchi" width={"520px"} open={aidraw} onClose={() => setAidraw(false)}>
                    <ChatIntelect />
                </Drawer>
            </div>
        </SavingLoaderProvider>
    );
}

export default Site;
